import { ReactElement, useMemo } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import cashbackIcon from '../../../assets/cashback.webp'
import clinicsIcon from '../../../assets/clinics.webp'
import dentistryIcon from '../../../assets/dentistry.webp'
import discountsIcon from '../../../assets/discounts.webp'
import drugsIcon from '../../../assets/drugs.webp'
import examsIcon from '../../../assets/exams.webp'
import healthIcon from '../../../assets/health.webp'
import { Swiper } from "../../swiper/swiper"
import { HeroProps } from "./hero-props"
import * as S from './hero-style'

export function Hero ({ id, ...props }: HeroProps): ReactElement {
  const link = useMemo(() => {
    return props.urlBuilder.build(props.values.button.link, props.params)
  }, [props])

  return <S.Container id={id}>
    <S.BannerContainer>
      <S.Wrapper>
        <S.BannerWrapper>
          <div>
            <S.BannerContent>
              <S.Title>{props.values.title}</S.Title>
              <S.Description dangerouslySetInnerHTML={{ __html: props.values.subtitle }} />
              <S.DescriptionContainer>
                <S.DescriptionTitle>Nas clínicas parceiras AmorSaúde, você tem:</S.DescriptionTitle>
                <S.DescriptionList>
                  <S.DescriptionListItem>Consultas e exames presenciais.</S.DescriptionListItem>
                  <S.DescriptionListItem>Diversas áreas médicas e odontologia.</S.DescriptionListItem>
                  <S.DescriptionListItem>Atendimento por telemedicina.</S.DescriptionListItem>
                </S.DescriptionList>
              </S.DescriptionContainer>
              <S.DesktopLink href={link}>{props.values.button.title}</S.DesktopLink>
            </S.BannerContent>
            <S.MobileLink href={link}>{props.values.button.title}</S.MobileLink>
          </div>
          <S.DesktopImage src={props.values.image} alt="" />
          {props.values.imageMobile && <S.MobileImage src={props.values.imageMobile} alt="" />}
          {!props.values.imageMobile && <S.MobileImage src={props.values.image} alt="" />}
        </S.BannerWrapper>
      </S.Wrapper>
    </S.BannerContainer>
    <S.BottomCards>
      <Swiper className="swiper" offset={24}>
        {props.values.items.includes('HEALTH') && <S.WhiteCard>
          <img src={healthIcon} alt="" />
          <S.WhiteCardTitle>Saúde</S.WhiteCardTitle>
          <S.WhiteCardText>Consulta médica presencial e teleconsulta - atendimento online</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('DENTISTRY') && <S.WhiteCard>
          <img src={dentistryIcon} alt="" />
          <S.WhiteCardTitle>Odontologia</S.WhiteCardTitle>
          <S.WhiteCardText>Tratamentos odontológicos especializados</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('EXAMS') && <S.WhiteCard>
          <img src={examsIcon} alt="" />
          <S.WhiteCardTitle>Exames</S.WhiteCardTitle>
          <S.WhiteCardText>Exames com até 70% de desconto</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('DRUGS') && <S.WhiteCard>
          <img src={drugsIcon} alt="" />
          <S.WhiteCardTitle>Medicamentos</S.WhiteCardTitle>
          <S.WhiteCardText>Medicamentos com até 35% de desconto nas redes Droga Raia e Drogasil</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('DISCOUNT') && <S.WhiteCard>
          <img src={discountsIcon} alt="" />
          <S.WhiteCardTitle>Descontos</S.WhiteCardTitle>
          <S.WhiteCardText>Descontos em milhares de lojas e estabelecimentos pelo app</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('CASH_BACK') && <S.WhiteCard>
          <img src={cashbackIcon} alt="" />
          <S.WhiteCardTitle>Cashback</S.WhiteCardTitle>
          <S.WhiteCardText>Cashback em milhares de lojas e estabelecimentos pelo app</S.WhiteCardText>
        </S.WhiteCard>}
        {props.values.items.includes('CLINICS') && <S.WhiteCard>
          <img src={clinicsIcon} alt="" />
          <S.WhiteCardTitle>Clínicas</S.WhiteCardTitle>
          <S.WhiteCardText>Mais de 450 clínicas parceiras de atendimento médico e odontológico</S.WhiteCardText>
        </S.WhiteCard>}
      </Swiper>
    </S.BottomCards>
  </S.Container>
}